module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (206).23754257.jpg";